module.exports = __webpack_public_path__ + "img/s3_collegue.264b8c2b.png";